import RouteDetailModalImage from '../components/RouteDetailModalImage.vue';
import Vue from 'vue';
const routeDetailModalImageHandler = (urlImage, selectedActivity) => {
  const vm = new Vue({
    ...RouteDetailModalImage,
    propsData: { urlImage, selectedActivity },
  });
  vm.$mount();
  vm.$bvModal.show('activity-image-form-modal');
};
export default routeDetailModalImageHandler;
